import FormLabel from 'general/components/Forms/FormLabel'
import InputNumber from 'general/components/Forms/InputNumber'
import Utils from 'general/utils/Utils'
import { event } from 'jquery'
import { useEffect } from 'react'

function FinalMoneyDisplay(props) {
  const { formik, autoCalculate, isAdjustInvoice, formatNumber } = props

  useEffect(() => {
    if (!autoCalculate) {
      let total = formik.values?.total
        ?.toString()
        ?.replaceAll('.', '')
        ?.replace(',', '.')
      let exchangedTotal = Utils.roundNumber(
        total * (formik?.values?.exchangeRate ?? 0),
        formatNumber?.exchangedDiscountMoney,
      )
      formik.setFieldValue('exchangedTotal', exchangedTotal)
    }
  }, [formik.values?.total])

  useEffect(() => {
    if (!autoCalculate) {
      let discountMoney = formik.values?.discountMoney
        ?.toString()
        ?.replaceAll('.', '')
        ?.replace(',', '.')
      let exchangedDiscountMoney = Utils.roundNumber(
        Number(discountMoney) * (formik?.values?.exchangeRate ?? 0),
        formatNumber?.exchangedDiscountMoney,
      )
      formik.setFieldValue('exchangedDiscountMoney', exchangedDiscountMoney)
    }
  }, [formik.values?.discountMoney])

  useEffect(() => {
    if (!autoCalculate) {
      let taxMoney = formik.values?.taxMoney
        ?.toString()
        ?.replaceAll('.', '')
        ?.replace(',', '.')
      let exchangedTaxMoney = Utils.roundNumber(
        taxMoney * (formik?.values?.exchangeRate ?? 0),
        formatNumber?.exchangedDiscountMoney,
      )
      formik.setFieldValue('exchangedTaxMoney', exchangedTaxMoney)
    }
  }, [formik.values?.taxMoney])

  useEffect(() => {
    if (!autoCalculate) {
      let totalAfterTax = formik.values?.totalAfterTax
        ?.toString()
        ?.replaceAll('.', '')
        ?.replace(',', '.')
      let exchangedTotalAfterTax = Utils.roundNumber(
        totalAfterTax * (formik?.values?.exchangeRate ?? 0),
        formatNumber?.exchangedDiscountMoney,
      )
      formik.setFieldValue('exchangedTotalAfterTax', exchangedTotalAfterTax)
    }
  }, [formik.values?.totalAfterTax])

  return (
    <div className="d-flex flex-column gap-2 max-w-100">
      <div className="d-flex flex-row align-items-center flex-grow-1">
        <FormLabel width="160px">
          Tổng tiền hàng
          {/* {JSON.stringify(formik.values)} */}:
        </FormLabel>
        <div className="d-flex flex-row flex-grow-1" style={{ gap: '10px' }}>
          {autoCalculate ? (
            <InputNumber
              name="total"
              systemConfigType={
                !['VNĐ', 'VND'].includes(formik.values.currency)
                  ? 'exchangeTotalCost'
                  : 'totalCost'
              }
              fieldProps={formik.getFieldProps('total')}
              fieldMeta={formik.getFieldMeta('total')}
              fieldHelper={formik.getFieldHelpers('total')}
              disabled={!autoCalculate ? false : true}
              // disabled={true}
              allowNegative={true}
              className="w-100"
            />
          ) : (
            <InputNumber
              name="total"
              systemConfigType={
                !['VNĐ', 'VND'].includes(formik.values.currency)
                  ? 'exchangeTotalCost'
                  : 'totalCost'
              }
              fieldProps={formik.getFieldProps('total')}
              fieldMeta={formik.getFieldMeta('total')}
              fieldHelper={formik.getFieldHelpers('total')}
              disabled={!autoCalculate ? false : true}
              // disabled={true}
              allowNegative={true}
              className="w-100"
              onChangeInput={(event) => {
                formik.setFieldValue(
                  'total',
                  event?.target.value?.replaceAll('.', ''),
                )

                let exchangedTotal = Utils.roundNumber(
                  Number(
                    event?.target.value?.replaceAll('.', '')?.replace(',', '.'),
                  ) * (formik?.values?.exchangeRate ?? 0),
                  formatNumber?.exchangeTotalCost,
                )
                formik.setFieldValue('exchangedTotal', exchangedTotal)
              }}
            />
          )}

          {!['VNĐ', 'VND'].includes(formik.values.currency) && (
            <InputNumber
              name="exchangedTotal"
              systemConfigType="exchangeTotalCost"
              fieldProps={formik.getFieldProps('exchangedTotal')}
              fieldMeta={formik.getFieldMeta('exchangedTotal')}
              fieldHelper={formik.getFieldHelpers('exchangedTotal')}
              // disabled={!autoCalculate ? false : true}
              disabled={true}
              className="w-100"
              allowNegative={true}
            />
          )}
        </div>
      </div>
      {formik.values.discountType !== 0 ? (
        <div className="d-flex flex-row align-items-center">
          <FormLabel width="160px">Tổng tiền chiết khấu:</FormLabel>
          <div className="d-flex flex-row flex-grow-1" style={{ gap: '10px' }}>
            {autoCalculate ? (
              <InputNumber
                name="discountMoney"
                systemConfigType="totalCost"
                fieldProps={formik.getFieldProps('discountMoney')}
                fieldMeta={formik.getFieldMeta('discountMoney')}
                fieldHelper={formik.getFieldHelpers('discountMoney')}
                disabled={!autoCalculate ? false : true}
                className="w-100"
                allowNegative={true}
              />
            ) : (
              <InputNumber
                name="discountMoney"
                systemConfigType="totalCost"
                fieldProps={formik.getFieldProps('discountMoney')}
                fieldMeta={formik.getFieldMeta('discountMoney')}
                fieldHelper={formik.getFieldHelpers('discountMoney')}
                disabled={!autoCalculate ? false : true}
                className="w-100"
                allowNegative={true}
                onChangeInput={(event) => {
                  // console.log('event', event?.target.values)
                  formik.setFieldValue(
                    'discountMoney',
                    event?.target.value?.replaceAll('.', ''),
                  )
                  let exchangedDiscountMoney = Utils.roundNumber(
                    Number(
                      event?.target.value
                        ?.replaceAll('.', '')
                        .replace(',', '.'),
                    ) * (formik?.values?.exchangeRate ?? 0),
                    formatNumber?.currencyExchange,
                  )
                  formik.setFieldValue(
                    'exchangedDiscountMoney',
                    exchangedDiscountMoney,
                  )
                }}
              />
            )}

            {!['VNĐ', 'VND'].includes(formik.values.currency) && (
              <InputNumber
                systemConfigType="currencyExchange"
                name="exchangedDiscountMoney"
                fieldProps={formik.getFieldProps('exchangedDiscountMoney')}
                fieldMeta={formik.getFieldMeta('exchangedDiscountMoney')}
                fieldHelper={formik.getFieldHelpers('exchangedDiscountMoney')}
                // disabled={!autoCalculate ? false : true}
                disabled={true}
                className="w-100"
                allowNegative={true}
              />
            )}
          </div>
        </div>
      ) : null}

      {parseInt(formik.values.serial?.charAt(0)) === 2 ? (
        <div className="d-flex flex-row align-items-center">
          <FormLabel width="160px">Tổng tiền thuế được giảm:</FormLabel>
          <div className="d-flex flex-row flex-grow-1" style={{ gap: '10px' }}>
            {autoCalculate ? (
              <InputNumber
                name="taxReduction"
                systemConfigType="totalCost"
                fieldProps={formik.getFieldProps('taxReduction')}
                fieldMeta={formik.getFieldMeta('taxReduction')}
                fieldHelper={formik.getFieldHelpers('taxReduction')}
                disabled={!autoCalculate ? false : true}
                className="w-100"
                allowNegative={true}
              />
            ) : (
              <InputNumber
                name="taxReduction"
                systemConfigType="totalCost"
                fieldProps={formik.getFieldProps('taxReduction')}
                fieldMeta={formik.getFieldMeta('taxReduction')}
                fieldHelper={formik.getFieldHelpers('taxReduction')}
                disabled={!autoCalculate ? false : true}
                className="w-100"
                allowNegative={true}
                onChangeInput={(event) => {
                  // console.log('event', event?.target.values)
                  formik.setFieldValue(
                    'taxReduction',
                    event?.target.value?.replaceAll('.', ''),
                  )
                }}
              />
            )}

            {!['VNĐ', 'VND'].includes(formik.values.currency) && (
              <InputNumber
                systemConfigType="ratio"
                name="exchangedTotalTaxReduction"
                fieldProps={formik.getFieldProps('exchangedTotalTaxReduction')}
                fieldMeta={formik.getFieldMeta('exchangedTotalTaxReduction')}
                fieldHelper={formik.getFieldHelpers(
                  'exchangedTotalTaxReduction',
                )}
                disabled={!autoCalculate ? false : true}
                className="w-100"
                allowNegative={true}
              />
            )}
          </div>
        </div>
      ) : null}

      <div className="d-flex flex-row align-items-center">
        {parseInt(formik.values?.serial?.charAt(0)) === 1 && (
          <>
            <FormLabel width="160px">Tiền thuế GTGT:</FormLabel>
            <div
              className="d-flex flex-row flex-grow-1"
              style={{ gap: '10px' }}
            >
              {autoCalculate ? (
                <InputNumber
                  name="taxMoney"
                  systemConfigType={
                    !['VNĐ', 'VND'].includes(formik.values.currency)
                      ? 'exchangeTotalCost'
                      : 'totalCost'
                  }
                  fieldProps={formik.getFieldProps('taxMoney')}
                  fieldMeta={formik.getFieldMeta('taxMoney')}
                  fieldHelper={formik.getFieldHelpers('taxMoney')}
                  disabled={
                    isAdjustInvoice
                      ? autoCalculate && formik.values.taxRate !== 'KHAC'
                        ? true
                        : false
                      : formik.values.taxRate === 'KHAC' || !autoCalculate
                        ? false
                        : true
                  }
                  className="w-100"
                  allowNegative={true}
                />
              ) : (
                <InputNumber
                  name="taxMoney"
                  systemConfigType={
                    !['VNĐ', 'VND'].includes(formik.values.currency)
                      ? 'exchangeTotalCost'
                      : 'totalCost'
                  }
                  fieldProps={formik.getFieldProps('taxMoney')}
                  fieldMeta={formik.getFieldMeta('taxMoney')}
                  fieldHelper={formik.getFieldHelpers('taxMoney')}
                  disabled={
                    isAdjustInvoice
                      ? autoCalculate && formik.values.taxRate !== 'KHAC'
                        ? true
                        : false
                      : formik.values.taxRate === 'KHAC' || !autoCalculate
                        ? false
                        : true
                  }
                  className="w-100"
                  allowNegative={true}
                  onChangeInput={(event) => {
                    // console.log('event', event?.target.values)
                    formik.setFieldValue(
                      'taxMoney',
                      event?.target.value?.replaceAll('.', ''),
                    )

                    let exchangedTaxMoney = Utils.roundNumber(
                      Number(
                        event?.target.value
                          ?.replaceAll('.', '')
                          ?.replace(',', '.'),
                      ) * (formik?.values?.exchangeRate ?? 0),
                      formatNumber?.exchangeTotalCost,
                    )
                    formik.setFieldValue('exchangedTaxMoney', exchangedTaxMoney)
                  }}
                />
              )}

              {!['VNĐ', 'VND'].includes(formik.values.currency) && (
                <InputNumber
                  name="exchangedTaxMoney"
                  systemConfigType="exchangeTotalCost"
                  fieldProps={formik.getFieldProps('exchangedTaxMoney')}
                  fieldMeta={formik.getFieldMeta('exchangedTaxMoney')}
                  fieldHelper={formik.getFieldHelpers('exchangedTaxMoney')}
                  // disabled={!autoCalculate ? false : true}
                  disabled={true}
                  className="w-100"
                  allowNegative={true}
                />
              )}
            </div>
          </>
        )}
      </div>
      <div className="d-flex flex-row align-items-center">
        <FormLabel width="160px" fontWeight="700">
          Tổng tiền thanh toán:
        </FormLabel>
        <div className="d-flex flex-row" style={{ gap: '10px' }}>
          {autoCalculate ? (
            <InputNumber
              name="totalAfterTax"
              systemConfigType={
                !['VNĐ', 'VND'].includes(formik.values.currency)
                  ? 'exchangeTotalCost'
                  : 'totalCost'
              }
              fieldProps={formik.getFieldProps('totalAfterTax')}
              fieldMeta={formik.getFieldMeta('totalAfterTax')}
              fieldHelper={formik.getFieldHelpers('totalAfterTax')}
              disabled={!autoCalculate ? false : true}
              className="w-100"
              fontWeight="700"
              allowNegative={true}
            />
          ) : (
            <InputNumber
              name="totalAfterTax"
              systemConfigType={
                !['VNĐ', 'VND'].includes(formik.values.currency)
                  ? 'exchangeTotalCost'
                  : 'totalCost'
              }
              fieldProps={formik.getFieldProps('totalAfterTax')}
              fieldMeta={formik.getFieldMeta('totalAfterTax')}
              fieldHelper={formik.getFieldHelpers('totalAfterTax')}
              disabled={!autoCalculate ? false : true}
              className="w-100"
              fontWeight="700"
              allowNegative={true}
              onChangeInput={(event) => {
                // console.log('event', event?.target.values)
                formik.setFieldValue(
                  'totalAfterTax',
                  event?.target.value?.replaceAll('.', ''),
                )
                let exchangedTotalAfterTax = Utils.roundNumber(
                  Number(
                    event?.target.value?.replaceAll('.', '')?.replace(',', '.'),
                  ) * (formik?.values?.exchangeRate ?? 0),
                  formatNumber?.exchangeTotalCost,
                )
                formik.setFieldValue(
                  'exchangedTotalAfterTax',
                  exchangedTotalAfterTax,
                )
              }}
            />
          )}

          {!['VNĐ', 'VND'].includes(formik.values.currency) && (
            <InputNumber
              name="exchangedTotalAfterTax"
              systemConfigType="exchangeTotalCost"
              fieldProps={formik.getFieldProps('exchangedTotalAfterTax')}
              fieldMeta={formik.getFieldMeta('exchangedTotalAfterTax')}
              fieldHelper={formik.getFieldHelpers('exchangedTotalAfterTax')}
              disabled={true}
              className="w-100"
              fontWeight="700"
              allowNegative={true}
            />
          )}
        </div>
      </div>
    </div>
  )
}

export default FinalMoneyDisplay
